import { Grid, GridItem, Skeleton, AspectRatio } from '@chakra-ui/react'
import { useState, type ReactElement } from 'react'
import useColCountObserver from '../../../../hooks/useColCountObserver'

const FolderGridLoader = ({scrollEl}: {scrollEl: HTMLDivElement | null}): ReactElement | null => 
{
  const [colCount, setColCount] = useState(4)
  useColCountObserver(scrollEl, setColCount)  
  return (
  <Grid
    gridTemplateColumns={`repeat(${colCount}, minmax(10px, 1fr))`}
    columnGap={6}
    rowGap={6}
    width="100%"
  >
    {Array.from({ length: colCount }).map((_, idx) => (
        <GridItem key={idx}>
          <Skeleton height="52px" weight="222px" borderRadius="0.5rem"/>
        </GridItem>
    ))}
  </Grid>
)
}

export default FolderGridLoader
